const readMoreBtns = document.querySelectorAll(".image-with-text-new-read-more-btn");
const imageTextMainContents = document.querySelectorAll(".image-with-text-new-block-main-content");

imageTextMainContents.forEach( itmc => {
    const imageTextContent = itmc.querySelector(".image-with-text-new-block-content");
    const readMoreBtn = itmc.querySelector(".image-with-text-new-read-more-btn");
    const contentHeight = imageTextContent.scrollHeight;
    if (contentHeight < 600) {
        readMoreBtn.style.cssText = "display: none;"
    }
});

readMoreBtns.forEach( rms => {
    rms.addEventListener("click", function(e) {
        const clicked = e.target.closest(".image-with-text-new-read-more-btn");
        clicked.classList.toggle("active");
        clicked.classList.contains("active") ? clicked.innerText = "- Read less" : clicked.innerText = "+ Read more";
        const imageTextContent = document.querySelector(`.image-with-text-new-block-content--${ clicked.dataset.btn }`);
        imageTextContent.classList.toggle("active");
    });
});



(function() {
  var announcementBar = document.querySelector('.announcement-bar-sticky');
  var header = document.querySelector('.shopify-section__header');
 
  if (!announcementBar || !header) return;
 
  function updateHeaderOffset() {
    header.style.top = announcementBar.offsetHeight - +1 + 'px';
  }
 
  window.addEventListener('resize', updateHeaderOffset);
  updateHeaderOffset();
})();